import { useMutation } from '@apollo/client/react'
import { gql } from '@apollo/client'

const SET_AGENT_GOAL = gql`
  mutation SetAgentGoal($clientId: ID!, $input: AgentGoalInput!) {
    setAgentGoal(clientId: $clientId, input: $input) { id status }
  }
`

const UPSERT_AGENT_PERSONA = gql`
  mutation UpsertAgentPersona($clientId: ID!, $input: AgentPersonaInput!) {
    upsertAgentPersona(clientId: $clientId, input: $input) { id name }
  }
`

const UPDATE_CLIENT_CHANNELS = gql`
  mutation UpdateClientChannels($id: ID!, $selectedContentTypes: [String!]!, $schedulingConfig: SchedulingConfigInput) {
    updateClient(id: $id, input: { selectedContentTypes: $selectedContentTypes, schedulingConfig: $schedulingConfig }) { id }
  }
`

export function useAgentSetup() {
  const [setAgentGoal, { loading: l1 }] = useMutation(SET_AGENT_GOAL)
  const [upsertAgentPersona, { loading: l2 }] = useMutation(UPSERT_AGENT_PERSONA)
  const [updateClient, { loading: l3 }] = useMutation(UPDATE_CLIENT_CHANNELS)
  return {
    setAgentGoal: (variables: Record<string, unknown>) => setAgentGoal({ variables }),
    upsertAgentPersona: (variables: Record<string, unknown>) => upsertAgentPersona({ variables }),
    updateClient: (variables: Record<string, unknown>) => updateClient({ variables }),
    loading: l1 || l2 || l3,
  }
}
